import { render } from "./FaqTab.vue?vue&type=template&id=488d183a&scoped=true"
import script from "./FaqTab.vue?vue&type=script&lang=js"
export * from "./FaqTab.vue?vue&type=script&lang=js"

import "./FaqTab.vue?vue&type=style&index=0&id=488d183a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-488d183a"

export default script